export default function CTimeH() {
  return <h2>C Time H</h2>;
}
